export const FEATURE_FLAGS = {
  investorMobileSubmenu: true,
}
